import async from 'components/template/Async';

export const Community = async(() => import('pages/marketplace/Community'));
